import { decamelizeKeys } from 'humps';
import { api, endpoints } from '@dom/utils';

const createInvoice = async reqObj => {
  try {
    const { data } = await api.postWithoutToken(endpoints.invoice.create, decamelizeKeys(reqObj));
    return data;
  } catch (e) {
    console.log(e);
  }
}

export default createInvoice;
